import { render } from "./AllTask.vue?vue&type=template&id=881d5856&scoped=true"
import script from "./AllTask.vue?vue&type=script&lang=js"
export * from "./AllTask.vue?vue&type=script&lang=js"

import "./AllTask.vue?vue&type=style&index=0&id=881d5856&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-881d5856"]])

export default __exports__